import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { IFactoid } from '../../types/builder';
import * as styles from './Factoids.css';

interface IFactoidsProps {
  items: IFactoid[];
}

export const Factoids: React.FC<IFactoidsProps> = ({ items }) => {
  return (
    <div className={styles['container']}>
      {items.map(({ count, text }, index) => (
        <div className={styles['item']} key={index}>
          <div className={styles['count']}>{count}</div>
          <div className={styles['text']}>
            <UIText2 fontWeight="700">{text}</UIText2>
          </div>
        </div>
      ))}
    </div>
  );
};
